<script>
import CourseList from '@/views/ExtendableBases/CourseList/'

export default {
  extends: CourseList
}
</script>
